import { getAutoLinks } from '../lib/autolinks';

/**
 * Plain text in which the names listed in the sheet's AUTO LINKS block (and config.js
 * LINK_MAP), and any email address, become links. `skip` is a name to leave unlinked.
 */
export default function LinkText({ text, skip }) {
  if (!text) return null;
  const { map, pattern } = getAutoLinks();
  return text.split(pattern).map((part, i) => {
    if (i % 2 === 0 || part === skip) return part;
    if (part.includes('@')) return <a key={i} className="inline-link" href={`mailto:${part}`}>{part}</a>;
    return <a key={i} className="inline-link" href={map[part]} target="_blank" rel="noopener noreferrer">{part}</a>;
  });
}
